export function isTimelineTimeWithinRecording(
  timeSeconds: number,
  recordingDurationSeconds: number,
): boolean {
  if (!Number.isFinite(timeSeconds) || timeSeconds < 0) {
    return false;
  }
  if (
    !Number.isFinite(recordingDurationSeconds) ||
    recordingDurationSeconds <= 0
  ) {
    return true;
  }
  return timeSeconds <= recordingDurationSeconds;
}

export function clampTimelineTimeToRecording(
  timeSeconds: number,
  recordingDurationSeconds: number,
  pageDurationSeconds = 0,
): number {
  if (!Number.isFinite(timeSeconds) || timeSeconds < 0) {
    return 0;
  }
  if (
    !Number.isFinite(recordingDurationSeconds) ||
    recordingDurationSeconds <= 0
  ) {
    return timeSeconds;
  }
  const latestPlayableStart = Math.max(
    0,
    recordingDurationSeconds - Math.max(0, pageDurationSeconds),
  );
  return Math.min(timeSeconds, latestPlayableStart);
}
